import {
    loadObjectFromServer,
    postData,
    getData,
    putData,
    deleteData
} from "@/utils";

export async function addSubscriber(payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await postData(
        APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS,
        payload
    );
    return response;

}

export async function uploadSubscribers(payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    const response = await postData(`${apiUrl}upload/`, payload);
    return response;
}

export async function updateSubscriber(id, payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    const response = await putData(`${apiUrl}${id}/`, payload);
    return response;
}

export async function deleteSubscriber(id) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    const response = await deleteData(`${apiUrl}${id}/`);
    return response;
}

export async function addSubscriberList(payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await postData(
        APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBER_LIST, payload
    );
    return response;
}

export async function getSubscribersList() {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await getData(APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBER_LIST);
    return response;
}

export async function getSubscribersPaginated(params) {
    let queryString = Object.keys(params)
        .map(function (key) {
            return `${key}=${params[key]}`;
        })
        .join("&");
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `${APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS}?${queryString}`;
    const response = await getData(apiUrl);
    return response;
}

export async function getLocationSubscribersPaginated(params, locationIds) {
    let queryString = Object.keys(params)
        .map(function (key) {
            return `${key}=${params[key]}`;
        })
        .join("&");
    let locationQueryString = locationIds
        .map(location_id => `location_id=${location_id}`)
        .join("&");
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let apiUrl = `${APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS}?${locationQueryString}&${queryString}`;    
    const response = await getData(apiUrl);
    return response;
}

export async function getLocationGroupSubscribersPaginated(params, locationGroupIds) {
    try {
        let queryString = Object.keys(params)
            .map(function (key) {
                return `${key}=${params[key]}`;
            })
            .join("&");
        let locationGroupQueryString = locationGroupIds
            .map(location_group_id => `location_group_id=${location_group_id.value}`)
            .join("&");
        const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
        let apiUrl = `${APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS}?${locationGroupQueryString}&${queryString}`;    
        const response = await getData(apiUrl);
        return response;
    } catch (error) {
        console.log('Error Subs:96: ', error)
        return {count: 0, next : null, previous : null, results : []};
    }
}

export async function getSubscribers() {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await getData(APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS);
    return response;
}

export async function updateSubscriberList(id, payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBER_LIST;
    const response = await putData(`${apiUrl}${id}`, payload);
    return response;
}

export async function deleteSubscriberList(id) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBER_LIST;
    const response = await deleteData(`${apiUrl}${id}`);
    return response;
}

export async function getSubscribersListSubscribers() {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await getData(
        APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBER_LIST_SUBSCRIBERS
    );
    return response;
}
export async function updateSubcriberProfile(id, payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    try {
        const response = await putData(`${apiUrl}${id}/profile/`, payload);
        return response;
    } catch (e) {
        return null;
    }
}

export async function getCards(id) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    try {
        const response = await getData(`${apiUrl}${id}/cards/`);
        return response;
    } catch (e) {
        return null;
    }
}

export async function addCard(id, payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    try {
        const response = await postData(`${apiUrl}${id}/cards/`, payload);
        return response;
    } catch (e) {
        return null;
    }
}

export async function deleteCard(id, card_id) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    try {
        const response = await deleteData(`${apiUrl}${id}/cards/${card_id}/`);
        return response;
    } catch (e) {
        return null;
    }
}

export async function getNotes(id) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    try {
        const response = await getData(`${apiUrl}${id}/notes/`);
        return response;
    } catch (e) {
        return null;
    }
}

export async function addNote(id, payload) {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const apiUrl = APP_ROUTES.SUBSCRIPTIONS_SUBSCRIBERS;
    try {
        const response = await postData(`${apiUrl}${id}/notes/`, payload);
        return response;
    } catch (e) {
        return null;
    }
}

export async function getLocationGuestsPaginated(params, locationIds) {
    let queryString = Object.keys(params)
        .map(function (key) {
            return `${key}=${params[key]}`;
        })
        .join("&");
    let locationQueryString = locationIds
        .map(location_id => `location_id=${location_id}`)
        .join("&");
    let apiUrl = `/pos/guests/?${locationQueryString}&${queryString}`;
    const response = await getData(apiUrl);
    return response;
}

export async function getLocationGroupGuestsPaginated(params, locationGroupIds) {
    let queryString = Object.keys(params)
        .map(function (key) {
            return `${key}=${params[key]}`;
        })
        .join("&");
    let locationGroupQueryString = locationGroupIds
        .map(location_group_id => `location_group_id=${location_group_id.value}`)
        .join("&");
    let apiUrl = `/pos/guests/?${locationGroupQueryString}&${queryString}`;
    const response = await getData(apiUrl);
    return response;
}

export async function getSubcriberProfile(id, pos_id=undefined, hashid=undefined) {
    const response = await getData(`/subscriptions/subscribers/${id}?hashid=${hashid}&pos_id=${pos_id}`);
    return response;
}

export async function getGuestProfile(id, pos_id=undefined, hashid=undefined) {
    const response = await getData(`/pos/guests/${id}?hashid=${hashid}&pos_id=${pos_id}`);
    return response;
}

export async function getChannels() {
    try {
      const response = await getData('/subscriptions/channels/');
      return response;
    } catch (e) {
      return null;
    }
}

export async function getS3Subscribers(locationsIds, is_subscriber = true, page = 1) {
    try {
        let queryString = Object.keys(locationsIds)
            .map(function (key) {
                return `location_id=${locationsIds[key]}`;
            })
            .join("&");
        let apiUrl = `/pos/guests-bigdata/?page=${page}&is_subscriber=${is_subscriber}&${queryString}`;
        
        const response = await getData(apiUrl);
        // let sample  = {"urls": response, "count": 98798}
        return response;
    } catch (error) {
        console.log('---errorr1: ', error)
    }
}

export async function getDeletedCustomers(customer_type="guests", pos_id=undefined) {
    try {
        let apiUrl = `/bigdata/get-deleted-customers/?customer_type=${customer_type}&pos_id=${pos_id}`
        const response = await getData(apiUrl);
        return response;    
    } catch (error) {
        console.log("Error:",error)
    }
    
}

export async function deletedCustomer(pk, hash_id, pos_id=undefined) {
    
    const response = await deleteData(`/pos/guests/${pk}/?hashid=${hash_id}&pos_id=${pos_id}`);
    return response;
}